export default __webpack_public_path__ + "static/media/menu_link_lottery_not_selected.1bb4d549.svg";